module.exports = __webpack_public_path__ + "static/media/img-portofolio.7f0e07ce.png";